import React, {useEffect, useState} from 'react';
import backImg from "../../images/Arrow.svg";
import close from "../../images/Close.svg";
import Main from "./Main";
import Permissions from "./Permissions";
import DbInfo from "./DbInfo";
import Progress from "../Componnets/Progress";
import UploadFile from "./UploadFile";
import SelectEventLog from "./SelectEventLog";
import DataPreview from "./DataPreview";
import SaveModal from "./SaveModal";
import GenerateConnector from "./GenerateConnector";
export default function DataConnectorTest(props) {
    const [showCloseModal , setShowCloseModal] = useState(false)
    const [step, setStep] = useState('db-info');
    const [page, setPage] = useState('generate-connector');
    const [uid, setUid] = useState('');
    const [dataMapping,setDataMapping] = useState([])
    const goToBack = () => {
        if(page === 'permissions')
            setPage('main')
        else if(page === 'upload-file')
            setPage('permissions')
        else if(page === 'db-info')
            setPage('permissions')
        else if(page === 'data-preview')
            setPage('upload-file')
    }
    // const page = props.match.params.page.toLowerCase();
    const closeModal = () => {
        if(page === 'main' || page === 'permissions')
            props.close()
        else
           setShowCloseModal(true)
    }
    return (
        <>
            <div className="modal-back"></div>
            <div className="modal fade-in-top wizard mt-6 d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        {(page !== 'main') &&
                            <img onClick={() => goToBack()} src={backImg} className="mr-32 pointer" alt="back"/>
                        }
                        <h3>
                            {page === 'main' && 'Data Connector Creator Wizard'}
                            {page === 'permissions' && 'Permissions'}
                            {page === 'db-info' && 'Enter DB Info'}
                            {page === 'upload-file' && 'Upload File'}
                            {page === 'select-event-log' && 'Select Event Log'}
                            {page === 'data-preview' && 'Data Preview'}
                            {page === 'generate-connector' && 'Zylem Connector'}
                        </h3>
                    </div>
                    {(page !== 'main' && page !== 'generate-connector')&&
                    <Progress page={page}/>
                    }
                    <img className="pointer" onClick={closeModal} src={close} alt="close"/>
                </div>
                {page === 'main' &&
                <Main goToNext={() => setPage('permissions')}
                      selectStep={step => setStep(step)}/>}
                {page === 'permissions' &&
                <Permissions goToNext={()=> setPage(step)}/>}
                {page === 'db-info' &&
                <DbInfo/>}
                {page === 'upload-file' &&
                <UploadFile setUid={uid => setUid(uid)} uid={uid} goToNext={()=> setPage(uid ? 'data-preview' : 'upload-file')} />}
                {page === 'select-event-log' && <SelectEventLog />}
                {page === 'generate-connector' && <GenerateConnector/>}
                {page === 'data-preview' && <DataPreview setDataMapping={data => setDataMapping(data)}  close={() => props.close()} uid={'16cc27d9-5453-4077-b928-743438fc7476'}/>}
            </div>
            {showCloseModal && <SaveModal getData={props.getData} dataMapping={dataMapping} uid={'16cc27d9-5453-4077-b928-743438fc7476'} close={() => props.close()}/>}
        </>
    );
}
